var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBetsFavOff = function SvgBetsFavOff(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970",
    transform: "translate(-14 -341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 36,
    height: 36,
    rx: 7,
    transform: "translate(14 341)",
    fill: "#0f40a9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_bet_favorite",
    "data-name": "icon bet favorite",
    transform: "translate(-256 -93.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M0,0H12.988V21.178L6.663,16.472,0,21.178Z",
    transform: "translate(279.387 441.983)",
    fill: "#0f40a9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M0,0H12.988V21.178L6.663,16.472,0,21.178Z",
    transform: "translate(279.387 441.983)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(285.25 438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    transform: "translate(-0.25 0.071)",
    fill: "#0f40a9",
    stroke: "#0f40a9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(2.255 1.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M11.994,15.642l-3.166-.227a.17.17,0,0,1-.148-.108L7.474,12.37a1.061,1.061,0,0,0-1.963,0L4.3,15.311a.177.177,0,0,1-.148.108l-3.161.227a1.045,1.045,0,0,0-.934.717,1.037,1.037,0,0,0,.315,1.145L2.821,19.53a.176.176,0,0,1,.058.175l-.746,3.052a1.032,1.032,0,0,0,.167.9,1.055,1.055,0,0,0,.833.415,1,1,0,0,0,.558-.169l2.674-1.664a.174.174,0,0,1,.183,0l2.7,1.658a1.011,1.011,0,0,0,.563.175,1.038,1.038,0,0,0,.8-.391,1.072,1.072,0,0,0,.2-.915l-.749-3.06a.178.178,0,0,1,.058-.177L12.611,17.5a1.062,1.062,0,0,0-.616-1.862ZM12.2,17,9.72,19.028a.824.824,0,0,0-.278.833l.749,3.055a.418.418,0,0,1-.079.362.389.389,0,0,1-.3.151.369.369,0,0,1-.212-.071L6.892,21.691a.823.823,0,0,0-.431-.122.811.811,0,0,0-.434.124L3.342,23.363a.393.393,0,0,1-.524-.1.375.375,0,0,1-.056-.347l.749-3.063a.826.826,0,0,0-.275-.828L.795,17.012a.411.411,0,0,1,.243-.719L4.2,16.065a.819.819,0,0,0,.7-.508l1.209-2.939a.411.411,0,0,1,.762,0l1.209,2.939a.819.819,0,0,0,.7.508l3.172.23a.4.4,0,0,1,.357.278A.408.408,0,0,1,12.2,17Z",
    transform: "translate(0 -11.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.7
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetsFavOff, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };